const urdu = {
    name: "Urdu",
    native_name: "اردو",
    code: "ur",
  };
  
  const ur = {
    translation: {
      report_bug: "بگ رپورٹ کریں",
      import: "درآمد کریں",
      file: "فائل",
      new: "نیا",
      new_window: "نیا ونڈو",
      open: "کھولیں",
      save: "محفوظ کریں",
      save_as: "کے طور پر محفوظ کریں",
      save_as_template: "ٹیمپلیٹ کے طور پر محفوظ کریں",
      template_saved: "ٹیمپلیٹ محفوظ ہو گیا!",
      rename: "نام تبدیل کریں",
      delete_diagram: "ڈایاگرام حذف کریں",
      are_you_sure_delete_diagram: "کیا آپ واقعی اس ڈایاگرام کو حذف کرنا چاہتے ہیں؟ یہ عمل ناقابل واپسی ہے۔",
      oops_smth_went_wrong: "اوہ! کچھ غلط ہو گیا۔",
      import_diagram: "ڈایاگرام درآمد کریں",
      import_from_source: "ماخذ سے درآمد کریں",
      export_as: "کے طور پر برآمد کریں",
      export_source: "ماخذ برآمد کریں",
      models: "ماڈلز",
      exit: "خارج کریں",
      edit: "ترمیم کریں",
      undo: "واپس",
      redo: "دوبارہ کریں",
      clear: "صاف کریں",
      are_you_sure_clear: "کیا آپ واقعی اس ڈایاگرام کو صاف کرنا چاہتے ہیں؟ یہ ناقابل واپسی ہے۔",
      cut: "کٹ",
      copy: "کاپی",
      paste: "پیسٹ",
      duplicate: "ڈپلیکیٹ",
      delete: "حذف کریں",
      copy_as_image: "تصویر کے طور پر کاپی کریں",
      view: "دیکھیں",
      header: "ہیڈر",
      sidebar: "سائیڈبار",
      issues: "مسائل",
      presentation_mode: "پیشکش موڈ",
      strict_mode: "سخت موڈ",
      field_details: "فیلڈ کی تفصیلات",
      reset_view: "دیکھنے کا انداز ری سیٹ کریں",
      show_grid: "گرڈ دکھائیں",
      show_cardinality: "کارڈینلٹی دکھائیں",
      theme: "تھیم",
      light: "روشن",
      dark: "تاریک",
      zoom_in: "زوم ان",
      zoom_out: "زوم آؤٹ",
      fullscreen: "پوری اسکرین",
      settings: "ترتیبات",
      show_timeline: "ٹائم لائن دکھائیں",
      autosave: "آٹو سیو",
      panning: "پیننگ",
      table_width: "ٹیبل کی چوڑائی",
      language: "زبان",
      flush_storage: "اسٹوریج صاف کریں",
      are_you_sure_flush_storage: "کیا آپ واقعی اسٹوریج کو صاف کرنا چاہتے ہیں؟ یہ آپ کے تمام ڈایاگرام اور کسٹم ٹیمپلیٹس کو ناقابل واپسی طور پر حذف کر دے گا۔",
      storage_flushed: "اسٹوریج صاف کر دیا گیا",
      help: "مدد",
      shortcuts: "شارٹ کٹس",
      ask_on_discord: "Discord پر پوچھیں",
      feedback: "فیڈبیک",
      no_changes: "کوئی تبدیلی نہیں",
      loading: "لوڈ ہو رہا ہے...",
      last_saved: "آخری بار محفوظ کیا گیا",
      saving: "محفوظ ہو رہا ہے...",
      failed_to_save: "محفوظ کرنے میں ناکام",
      fit_window_reset: "ونڈو کے مطابق بنائیں / ری سیٹ کریں",
      zoom: "زوم",
      add_table: "ٹیبل شامل کریں",
      add_area: "ایریا شامل کریں",
      add_note: "نوٹ شامل کریں",
      add_type: "قسم شامل کریں",
      to_do: "کرنے کے لئے",
      tables: "ٹیبلز",
      relationships: "تعلقات",
      subject_areas: "موضوع کے علاقے",
      notes: "نوٹس",
      types: "اقسام",
      search: "تلاش کریں...",
      no_tables: "کوئی ٹیبل نہیں",
      no_tables_text: "اپنا ڈایاگرام بنانا شروع کریں!",
      no_relationships: "کوئی تعلقات نہیں",
      no_relationships_text: "تعلقات بنانے کے لئے فیلڈز کو جوڑیں!",
      no_subject_areas: "کوئی موضوع کے علاقے نہیں",
      no_subject_areas_text: "ٹیبلز کو گروپ کریں اور موضوع کے علاقے شامل کریں!",
      no_notes: "کوئی نوٹس نہیں",
      no_notes_text: "اضافی معلومات کو ریکارڈ کرنے کے لیے نوٹس کا استعمال کریں",
      no_types: "کوئی قسم نہیں",
      no_types_text: "اپنے کسٹم ڈیٹا کی اقسام بنائیں",
      no_issues: "کوئی مسائل نہیں ملے",
      strict_mode_is_on_no_issues: "سخت موڈ بند ہے اس لئے کوئی مسائل نہیں دکھائے جا رہے ہیں۔",
      name: "نام",
      type: "قسم",
      null: "نل",
      not_null: "نل نہیں",
      primary: "پرائمری",
      unique: "یونیک",
      autoincrement: "خودکار بڑھا",
      default_value: "پہلے سے طے شدہ",
      check: "چیک ایکسپریشن",
      this_will_appear_as_is: "*یہ اسکرپٹ میں جیسا ہے ویسا ہی نظر آئے گا۔",
      comment: "تبصرہ",
      add_field: "فیلڈ شامل کریں",
      values: "ویلیوز",
      size: "سائز",
      precision: "درستگی",
      set_precision: "درستگی سیٹ کریں: (سائز، عدد)",
      use_for_batch_input: "بیچ ان پٹ کے لئے استعمال کریں",
      indices: "اشاریہ",
      add_index: "انڈیکس شامل کریں",
      select_fields: "فیلڈز منتخب کریں",
      title: "عنوان",
      not_set: "سیٹ نہیں کیا گیا",
      foreign: "غیر ملکی",
      cardinality: "کارڈینلٹی",
      on_update: "اپ ڈیٹ پر",
      on_delete: "حذف کرنے پر",
      swap: "تبادلہ",
      one_to_one: "ایک سے ایک",
      one_to_many: "ایک سے بہت",
      many_to_one: "بہت سے ایک",
      content: "مواد",
      timeline: "ٹائم لائن",
      priority: "ترجیح",
      none: "کوئی نہیں",
      low: "کم",
      medium: "درمیانہ",
      high: "اعلی",
      sort_by: "کے لحاظ سے ترتیب دیں",
      my_order: "میرا ترتیب",
      completed: "مکمل",
      alphabetically: "حروف تہجی کے لحاظ سے",
      add_task: "کام شامل کریں",
      details: "تفصیلات",
      no_tasks: "آپ کے پاس ابھی تک کوئی کام نہیں ہے۔",
      no_activity: "آپ کے پاس ابھی تک کوئی سرگرمی نہیں ہے۔",
    },
  };
  
  export { ur, urdu };
  